/* NW sengeguide: rigtigt materiale i kurven. Tilfoejet 28-08-2026.

   BAGGRUND: realAdd i page.find-dit-sengetoj.liquid slaar lagen og pudebetraek op
   i en hardkodet tabel der KUN indeholder bambusvarianter. Selv naar guiden viser
   et egyptisk kuvertlagen, ville kurven derfor faa et bambuslagen.

   Vi roerer ikke bambus-vejen, som er verificeret ende til ende. For de oevrige
   materialer slaar vi guidens egne tilvalg fra lige foer den bygger kurven,
   laegger de rigtige varer i selv, og saetter valgene tilbage bagefter.

   HVORFOR EN ACCESSOR: guidens wire() koerer window.addToCart=realAdd igen ved
   DOMContentLoaded, load, 1500 ms og 3500 ms. En almindelig wrapper ville blive
   overskrevet. Med en getter/setter fanger vi deres tildeling i stedet.

   HVORFOR VI HENTER PRODUKTET SELV: foerste version slog varianten op i cachen
   hos nw-sg-priser.js. Var produktet ikke naaet at blive hentet, faldt linjen
   tavst ud, og kurven kom ikke til at matche det lovede. Nu venter vi paa svaret. */
(function(){
  'use strict';

  var deres = (typeof window.addToCart === 'function') ? window.addToCart : null;
  var cache = {};

  function norm(s){ return String(s || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '').replace(/cm/g, ''); }

  function hentProdukt(h){
    if(!h){ return Promise.resolve(null); }
    if(cache[h]){ return Promise.resolve(cache[h]); }
    return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ cache[h] = p; return p; })
      .catch(function(){ return null; });
  }

  function findVariant(p, st){
    if(!p || !p.variants){ return null; }
    var n = norm(st), i, j;
    for(i = 0; i < p.variants.length; i++){
      var o = p.variants[i].options || [];
      for(j = 0; j < o.length; j++){ if(norm(o[j]) === n){ return p.variants[i]; } }
    }
    for(i = 0; i < p.variants.length; i++){
      if(norm(p.variants[i].title).indexOf(n) === 0){ return p.variants[i]; }
    }
    if(p.variants.length === 1){ return p.variants[0]; }
    return null;
  }

  function linje(handle, stoerrelse, antal){
    return hentProdukt(handle).then(function(p){
      var v = findVariant(p, stoerrelse);
      if(v && v.available !== false){ return { id: v.id, quantity: antal || 1 }; }
      return null;
    });
  }

  function byg(mat, s){
    var opgaver = [];
    try{
      if(s.lagenOn){
        var lh = (window.nwSgTilvalg.lagenHandles(mat, s.lagenType) || [])[s.lagenCi || 0];
        if(lh){ opgaver.push(linje(lh, s.lagenStr, s.lagenQty)); }
      }
      if(s.pbQty > 0){
        var ph = (window.nwSgTilvalg.pbHandles(mat) || [])[s.pbCi || 0];
        if(ph){ opgaver.push(linje(ph, s.pbStr, s.pbQty)); }
      }
    }catch(e){}
    if(!opgaver.length){ return Promise.resolve([]); }
    return Promise.all(opgaver).then(function(a){
      return a.filter(function(x){ return !!x; });
    });
  }

  function laegIKurv(items){
    if(!items.length){ return Promise.resolve(); }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(){}).catch(function(){});
  }

  function min(e){
    var mat;
    try{ mat = chosen.mat; }catch(err){ mat = null; }

    if(!mat || mat === 'bambus' || !window.nwSgTilvalg){
      if(typeof deres === 'function'){ return deres.apply(this, arguments); }
      return;
    }

    if(e && e.preventDefault){ e.preventDefault(); }
    var self = this, args = arguments;

    var s = {
      lagenOn: !!(chosen.lagen && chosen.lagen.on),
      lagenCi: chosen.lagen ? (chosen.lagen.ci || 0) : 0,
      lagenType: chosen.lagen ? chosen.lagen.type : 'box',
      lagenStr: chosen.lagen ? (chosen.lagen.size || chosen.size) : null,
      lagenQty: chosen.lagen ? (chosen.lagen.qty || 1) : 1,
      pbQty: chosen.pb ? (chosen.pb.qty || 0) : 0,
      pbCi: chosen.pb ? (chosen.pb.ci || 0) : 0,
      pbStr: chosen.pb ? (chosen.pb.size || '60×63') : '60×63'
    };

    byg(mat, s).then(function(mine){
      /* Slaa guidens egne bambus-tilvalg fra, saa realAdd kun tager dynebetraek,
         hovedpude, vaskemiddel og dyne med. Gemmes og gendannes bagefter. */
      try{
        if(chosen.lagen){ chosen.lagen.on = false; }
        if(chosen.pb){ chosen.pb.qty = 0; }
      }catch(err){}

      return laegIKurv(mine).then(function(){
        try{ if(typeof deres === 'function'){ deres.apply(self, args); } }catch(err){}
        setTimeout(function(){
          try{
            if(chosen.lagen){ chosen.lagen.on = s.lagenOn; }
            if(chosen.pb){ chosen.pb.qty = s.pbQty; }
          }catch(err){}
        }, 0);
      });
    });

    return false;
  }

  try{
    Object.defineProperty(window, 'addToCart', {
      configurable: true,
      get: function(){ return min; },
      set: function(f){ if(typeof f === 'function' && f !== min){ deres = f; } }
    });
  }catch(e){
    var gentag = function(){
      if(typeof window.addToCart === 'function' && window.addToCart !== min){
        deres = window.addToCart;
        window.addToCart = min;
      }
    };
    gentag();
    setTimeout(gentag, 2000);
    setTimeout(gentag, 4000);
  }
})();